import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    title: "The End of Limits",
    body: "Your business no longer sleeps. Alkyrvis deploys a digital workforce that operates 24 hours a day, 365 days a year — no holidays, no downtime, no ceiling on output.",
  },
  {
    n: "02",
    title: "Specialised Intelligence",
    body: "Every AI has a purpose. Finance. Sales. Marketing. Operations. HR. Support. Analytics. Administration. Each agent is a specialist — together they behave like a company.",
  },
  {
    n: "03",
    title: "Total Autonomy",
    body: "Rather than replacing people, Alkyrvis augments your business. Agents that collaborate, decide and execute as one intelligent workforce — so your team can focus on what matters.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative mx-auto max-w-7xl px-6 py-32 lg:px-10 lg:py-44"
    >
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-gold">
          The Manifesto
        </p>
      </Reveal>
      <div className="mt-20 space-y-28 lg:space-y-36">
        {CHAPTERS.map((c, i) => (
          <div
            key={c.n}
            className={`relative flex ${
              i % 2 === 1 ? "justify-end" : "justify-start"
            }`}
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <span
              aria-hidden
              className="pointer-events-none absolute -top-16 select-none font-display text-[26vw] font-semibold leading-none text-white/[0.04] lg:-top-24 lg:text-[15vw]"
              style={i % 2 === 1 ? { right: 0 } : { left: 0 }}
            >
              {c.n}
            </span>
            <div className="relative max-w-xl">
              <Reveal>
                <p className="font-mono text-xs tracking-[0.3em] text-gold/70">
                  CHAPTER {c.n}
                </p>
              </Reveal>
              <Reveal delay={0.1}>
                <h3 className="mt-4 font-display text-3xl font-light tracking-tight text-[#F5F5F5] md:text-5xl">
                  {c.title}
                </h3>
              </Reveal>
              <Reveal delay={0.2}>
                <p className="mt-6 text-base leading-relaxed text-[#A3A3A3] md:text-lg">
                  {c.body}
                </p>
              </Reveal>
              <Reveal delay={0.28}>
                <div className="mt-8 h-px w-24 bg-gradient-to-r from-gold/60 to-transparent" />
              </Reveal>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
